export default "__VITE_ASSET__NDtKProX__"